var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_THEMATIC_CONTENT_REQUEST, GET_THEMATIC_CONTENT_REQUEST_ERROR, GET_THEMATIC_CONTENT_REQUEST_SUCCESS } from "../actions/getThematicContent";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getThematicContent(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_THEMATIC_CONTENT_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_THEMATIC_CONTENT_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_THEMATIC_CONTENT_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getThematicContent.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_THEMATIC_CONTENT_REQUEST, GET_THEMATIC_CONTENT_REQUEST_ERROR, GET_THEMATIC_CONTENT_REQUEST_SUCCESS } from "../actions/getThematicContent";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getThematicContent(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_THEMATIC_CONTENT_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_THEMATIC_CONTENT_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_THEMATIC_CONTENT_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getThematicContent.js.map